import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment';
import { ContactLocalMission, ContactLocalMissionWithZipcode } from '@models/event/contact';
import { LocalMissionEvent } from '@models/event/local-mission-event';
import { CreateOrganizationRequest, CreateOrganizationResponse } from '@models/organization/create-organization';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LocalMissionWebservice {
  constructor(private readonly http: HttpClient) {}

  // tslint:disable: no-duplicate-string
  getLocalMissionOrganization(token: string): Observable<CreateOrganizationResponse> {
    return this.http.get<CreateOrganizationResponse>(`${environment.api.organization}/v1/self/organization`, {
      headers: {
        'X-AUTH-TOKEN': token,
      },
    });
  }

  createLocalMissionOrganization(organization: CreateOrganizationRequest): Observable<CreateOrganizationResponse> {
    return this.http.post<CreateOrganizationResponse>(
      `${environment.api.event}/v1/local_mission/organizations`,
      organization
    );
  }

  updateLocalMissionOrganization(
    organization: CreateOrganizationRequest,
    token: string
  ): Observable<CreateOrganizationResponse> {
    return this.http.put<CreateOrganizationResponse>(
      `${environment.api.organization}/v1/self/organization`,
      organization,
      {
        headers: {
          'X-AUTH-TOKEN': token,
        },
      }
    );
  }

  createLocalMissionEvent(event: LocalMissionEvent): Observable<Event> {
    return this.http.post<Event>(`${environment.api.event}/v1/local_mission/events`, event);
  }

  updateLocalMissionEvent(
    eventId: string,
    event: LocalMissionEvent,
    token: string
  ): Observable<CreateOrganizationResponse> {
    return this.http.put<CreateOrganizationResponse>(`${environment.api.organization}/v1/events/${eventId}`, event, {
      headers: {
        'X-AUTH-TOKEN': token,
      },
    });
  }

  sendContactMail(contactLocalMission: ContactLocalMission): Observable<unknown> {
    return this.http.post<ContactLocalMission>(
      `${environment.api.event}/v1/local_mission/contact`,
      contactLocalMission
    );
  }

  sendContactMailWithZipcode(contactLocalMission: ContactLocalMissionWithZipcode): Observable<unknown> {
    return this.http.post<ContactLocalMissionWithZipcode>(
      `${environment.api.event}/v1/cej/mission/contact`,
      contactLocalMission
    );
  }
}
